import { render, staticRenderFns } from "./SchemeView.vue?vue&type=template&id=9c1a5c16&scoped=true"
import script from "./SchemeView.vue?vue&type=script&lang=js"
export * from "./SchemeView.vue?vue&type=script&lang=js"
import style0 from "./SchemeView.vue?vue&type=style&index=0&id=9c1a5c16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c1a5c16",
  null
  
)

export default component.exports